import React from "react";

import { useTranslation } from "react-i18next";

import { FormTextInput } from "@/uiKit/molecules/form/FormTextInput.tsx";

export type PatientFirstNameFormFieldProps = {
  name?: string;
  labelType?: "left" | "default";
  className?: string;
};

export const PatientFirstNameFormField: React.FC<PatientFirstNameFormFieldProps> = ({
  name = "givenName",
  labelType = "default",
  className,
}) => {
  const { t } = useTranslation();
  return (
    <FormTextInput
      id="patient-firstname-form-field"
      name={name}
      label={t("profile.firstname")}
      labelType={labelType}
      autoComplete="given-name"
      className={className}
      reserveErrorSpace
    />
  );
};
